import request from './request'
import appConfig from './../config/app'
import api from '../api'
import searchable from '@/services/searchable'
import resource from '@/services/resource'

export default {
  baseUrl: `${process.env.VUE_APP_AUTH_API}/api`,
  url: 'permission',
  ...api,
  ...resource,
  ...searchable,
  namespaced: true,
  strict: appConfig.store.strict,
  state: {
    baseURL: appConfig.services.authentication.baseURl,
    url: '/api/permission',
    permissionList: []
  },
  mutations: {
    setList (state, payload) {
      state.permissionList = payload
    }
  },
  actions: {
    /**
     * Action to update field value
     *
     * @param {state, commit} commit
     * @param {payload} payload
     * @return void
     */
    async populatePermissionList ({ state, commit }) {
      const payload = {
        baseURL: state.baseURL,
        url: state.url
      }

      await request.get({}, payload)
        .then(({ data }) => {
          commit('setList', data)
        })
        .catch(({ response }) => {
          throw response
        })
    },
    /**
     * empty listing
     *
     * @param {commit} commit
     * @return void
     */
    async clearPermissionList ({ commit }) {
      commit('setList', [])
    }
  }
}
